import { FormValues } from '@/ui/components/customFieldGroupControl/CreateEditCustomFieldSidebar';
import { CustomFieldType } from '@payaca/custom-fields';
import { useFormContext } from 'react-hook-form';
import { PathToFieldsetChild } from '../types';

type UseFieldsetChildFieldConfig = {
  fieldPath?: PathToFieldsetChild;
  expectedType: CustomFieldType;
};

export function useFieldsetChildField(config: UseFieldsetChildFieldConfig) {
  const { control, watch } = useFormContext<FormValues>();

  const namePrefix = config.fieldPath || '';

  if (!namePrefix) return null;

  const type = watch(`${namePrefix}.type`);

  if (type !== config.expectedType) return null;

  return {
    namePrefix,
    control,
  };
}
